export const environment = {
  production: false,
  env: 'Desarrollo',
  HomeTitle:'Aeromar - Development environment',
  ApiUrl: "https://aesrjapidev.clavisco.com/",
  recatpchaSiteKey: '6Ld-kWAqAAAAAFiNdWb_qRHJX56XFCJETQvTBRtp',
  LogRocketId: ''
};
